<template>
  <div class="skill">
    <div class="row">
      <div class="col">
        <under-input v-model="item.name">Name</under-input>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <under-select
          v-model="item.attribute"
          :options="$rulesets[this.ruleset].attributeOptions()"
        >Attribute</under-select>
      </div>
      <div class="col-3">
        <under-select v-model="item.score" :options="diceOptions">Dice</under-select>
      </div>
      <div class="col-2">
        <under-input v-model.number="item.misc" type="number" maxlength="2">Misc</under-input>
      </div>
    </div>
  </div>
</template>
<script>
import UnderCheckbox from "../shared/_UnderCheckbox.vue";
import UnderInput from "../shared/_UnderInput.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import UnderText from "../shared/_UnderText.vue";

export default {
  name: "sheet-skills-savage-worlds",
  components: {
    UnderCheckbox,
    UnderInput,
    UnderSelect,
    UnderText
  },
  props: ["section", "item", "ruleset", "attribute"],
  computed: {
    diceOptions() {
      let options = [{ text: "", value: 0 }];
      let diceOptions = this.$rulesets[this.ruleset].diceOptions;
      var all = [...options, ...diceOptions];
      return all;
    }
  }
};
</script>
